import React, { useEffect } from "react"
import { Panel } from "primereact/panel"
import { useHistory, useParams } from "react-router-dom"
import { GlobalContext } from "../../../../context";
import { TawreedForm, TawreedFormField, TawreedFormMode, TawreedFormSubmitAction, TawreedFormSubmitCallback, TawreedFormSubmitProps, TawreedInputFile, TawreedInputNumber, TawreedInputText, TawreedSitesDropdown } from "../../../../common";
import { tawreedTranslationService } from "../../../../common/translations";
import { PartnersService } from "../../../partners/domain";
import { UsersService } from "../../../users/domain";
import { TawreedFile } from "../../../upload";
import { TawreedActionName } from "../../../../common/actions";
import { PrimeIcons } from "primereact/api";
import { toastService } from "../../../notifications/domain";
import { TopupOnboardDto, WalletService } from "../../domain";


export const TopUpOnBoardForm: React.FC = () => {

    const { id } = useParams<{ id: string | undefined }>();
    const { auth: { user } } = React.useContext(GlobalContext);
    const service: WalletService = React.useMemo(() => new WalletService(), []);
    const partnerService: PartnersService = React.useMemo(() => new PartnersService(), []);
    const userService: UsersService = React.useMemo(() => new UsersService(), []);

    const [loading, setLoading] = React.useState<boolean>(false);
    const [mode, setMode] = React.useState<TawreedFormMode>('Create');
    const [commercialRecordForm, setCommercialRecordForm] = React.useState<File | undefined>();
    const [idImage, setIdImage] = React.useState<File | undefined>();

    const [data, setData] = React.useState<TopupOnboardDto>({
        partnerId: user?.partnerId!
    });

    const history = useHistory();

    React.useEffect(() => {
        let mounted = true;
        if (id) {
            setData({ ...data, topUpPartnerId: Number.parseInt(id) })
            if (mounted) {
                setMode('Create');
                // setData({});
            }
        } else {

        }
        return () => {
            mounted = false;
        };
    }, [id, service]);

    useEffect(() => {
        let document = "";
        if (idImage) {
            let reader = new FileReader();
            reader.readAsDataURL(idImage);
            reader.onload = function () {
                document = reader.result as string;
                let documentParts = document.split(',');
                if (documentParts.length > 1) {
                    document = documentParts[1];
                }
                else {
                    document = documentParts[0];
                }
                setData(
                    {...data, idImage: document}
                );
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
                setData(
                    {...data, idImage: ""}
                );
            };
        }
    }, [idImage]);

    useEffect(() => {
        let document = "";
        if (commercialRecordForm) {
            let reader = new FileReader();
            reader.readAsDataURL(commercialRecordForm);
            reader.onload = function () {
                document = reader.result as string;
                let documentParts = document.split(',');
                if (documentParts.length > 1) {
                    document = documentParts[1];
                }
                else {
                    document = documentParts[0];
                }
                setData(
                    {...data, commercialRecordForm: document}
                );
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
                setData(
                    {...data, commercialRecordForm: ""}
                );
            };
        }
    }, [commercialRecordForm]);

    const onCreateOrSave = (data: TopupOnboardDto, cb: TawreedFormSubmitCallback<TopupOnboardDto>): Promise<void> => {
        return new Promise((resolve, reject) => {
            if (!commercialRecordForm || !idImage) {
                toastService.show({ detail: tawreedTranslationService.translate('msg_files_error'), severity: 'error' })
                reject();
                return;
            }
            setLoading(true);
            return service.createOrUpdate(data)
                .then(res => {
                    setLoading(false);
                    console.log(res);

                    if (res) {
                        history.goBack();
                    }
                })
                .catch(err => {
                    setLoading(false);
                    cb(err);
                });
        });

    }

    const onSubmit: TawreedFormSubmitProps<TopupOnboardDto> = {
        showButton: true,
        resetOnSubmit: false,
        onSubmit: new TawreedFormSubmitAction<TopupOnboardDto>
            (TawreedActionName.OnBoard, 'lbl_save', PrimeIcons.SAVE, onCreateOrSave, 'p-button-text mr-1'),
    };

    return (
        <TawreedForm title="lbl_topup_partners_onboard"
            dataKey="paymentPartnerOnboardId" data={data}
            submit={onSubmit}
            loading={loading} mode={mode}
            useBack=".." className="grid form-grid">
            <Panel header={tawreedTranslationService.translate('lbl_general_information')} className="col-12">
                <div className="grid">
                    <TawreedFormField title="lbl_payment_onboard_commercialRecordForm" className="field col-12 align" name="file">
                        <TawreedInputFile render='standalone' name="file" onChange={
                            (e: TawreedFile | undefined) => setCommercialRecordForm(e && e.value instanceof File ? e.value : undefined)
                        } value={commercialRecordForm} />
                    </TawreedFormField>
                    <TawreedFormField title="lbl_payment_onboard_idImage" className="field col-12 align" name="file">
                        <TawreedInputFile render='standalone' name="file" onChange={
                            (e: TawreedFile | undefined) => setIdImage(e && e.value instanceof File ? e.value : undefined)
                        } value={idImage} />
                    </TawreedFormField>
                </div>
            </Panel>
        </TawreedForm>
    )
}
